import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import Auth from './auth';

Vue.config.productionTip = false;

Vue.use(Auth);

Vue.filter("formatDate", function (value) {
  if (!value) return "";
  value = value.toString();
  var ft = value.indexOf("T");
  if(ft>0){
    value = value.substring(0,ft);
  }
  var exp = value.split("-");
  return exp[2] + "/" + exp[1] + "/" + exp[0];
});

Vue.filter("formatTime", function (value) {
  if (!value) return "";
  value = value.toString();
  var ft = value.indexOf("T");
  if(ft>0){
    value = value.substring(ft+1);
  }
  var fp = value.indexOf(".");
  if(fp>0){
    value = value.substring(0,fp);
  }
  //var exp = value.split(":");
  //return exp[0] + "/" + exp[1] + "/" + exp[0];
  return value;
});

Vue.filter("formatMoney", function(value) {
  var val = (value / 1).toFixed(2).replace(".", ",");
  return val;
});

Vue.filter("formatMinutos", function (value) {
  var hd = parseInt(value / 60);
  var hr = value % 60;
  if(parseInt(hr)<10){
    hr = "0" + hr;
  }
  return hd +":"+hr;
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');